import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import getSetCookie from '../../cookie';
import CheckoutHeader from '../../desktop/components/Checkout/CheckoutHeader/CheckoutHeader';
import Loader from '../Loader/Loader';
import './JusPayment.scss';

const JusPayment = React.memo(props => {
    const { paymentData } = useSelector(x => x.checkout);
    const { localeInfo } = useSelector(state => state.common);
    const [loadingJusScript, setLoadingJusScript] = useState(true);
    const getPayment = () => {
        if (paymentData?.result?.payment?.actionInfo?.requestParams) {
            const { payload, requestId, service } = paymentData.result.payment.actionInfo.requestParams;
            const parsePayload = JSON.parse(payload);
            const { language, orderId, clientId, merchantKeyId, orderDetails, signature, amount, customerId, customerEmail, customerMobile, environment, merchantId, action } = parsePayload;
            const processPayload = {
                requestId,
                service,
                payload: {
                    action,
                    merchantId,
                    clientId,
                    orderId,
                    amount,
                    customerId,
                    customerEmail,
                    customerMobile,
                    orderDetails,
                    signature,
                    merchantKeyId,
                    language,
                    environment
                }
            };
            window.hyperServicesObject.process(processPayload);
            setLoadingJusScript(false);
        } else if (getSetCookie.getCookie('orderId')) {
            props.history.push('/checkout/onepage/retrypayment');
        } else {
            props.history.push('/');
        }
    };

    useEffect(() => {
        getPayment();
    }, []);


    return (
        <div className={`qr-payment-container ${process.env.CLIENT_TYPE === 'desktop' ? 'display-flex' : ''} flex-column`}>
            {loadingJusScript && <Loader fullpage />}
            <CheckoutHeader pathPrefix={localeInfo.pathPrefix} client={process.env.CLIENT_TYPE} logoCenter="https://static.lenskart.com/media/desktop/img/checkout_Lenskart_logo_2x.png" />
            <div id="jusFrame"></div>
        </div>
    );
});

export default JusPayment;
